import { MDBInput } from "mdb-react-ui-kit";
import { useState } from "react";
import { SketchPicker } from "react-color";

const ColorPicker = (props) => {
    const {label, color, setColor} = props;
    const [showColorPicker, setShowColorPicker] = useState(false);

    const toggleColorPicker = () => {
        setShowColorPicker(!showColorPicker);
    }
    const hideColorPicker = () => {
        setShowColorPicker(false);
    }
    const handleColorChange = (color) => {
        setColor(color.hex);
    }
    const handleInputChange = (e) => {
        setColor(e.target.value);
    }

    return (
    <div className={`d-flex align-items-center ${props.className}`}>
        <label className="me-2">{label}</label>
        <div className="d-flex align-items-center">
            <div className="color-picker">
                <div className="swatch" onClick={() => toggleColorPicker('bg_color')}>
                    <div className="color" style={{ background: color }}></div>
                </div>
                {showColorPicker && <div className="picker-popover ms-2 mt-1">
                    <div className="cover" onClick={hideColorPicker} />
                    <SketchPicker color={color} onChange={handleColorChange} />
                </div>}
            </div>
            <div className="ms-2" style={{width:100}}>
                <MDBInput value={color ?? ''} onChange={handleInputChange} style={{padding:'0px 5px'}} />
            </div>
        </div>
    </div>
    )
}

export default ColorPicker;